export const toSessionIdFromWindow = (screen: any = window) =>
  screen?.amplitude ? screen.amplitude.getInstance()._sessionId : undefined;
